<template>
  <div class="store-detail">
    <NavHeaderBar :showSearch="false" :navBarTitle="$t('shared.title.storeInfo')">
      <div class="right-header" v-if="paramsUrl.readOnly !== 'true'">
        <div
          class="project-filter"
          slot="right"
        >
          <van-popover
            v-model="showPopover"
            trigger="click"
            :actions="actions"
            @select="onSelect"
            placement="left-start"
            get-container=".store-detail"
          >
            <template #reference>
              <van-icon name="ellipsis" />
            </template>
          </van-popover>
        </div>
      </div>
    </NavHeaderBar>
    <div class="detail-main-content">
      <div class="mark-info">
        <span class="customer-name">{{ customerInfo.customerName }}</span>
      </div>
      <XuStoreInfo :customerInfo="customerInfo" :shelfList="shelfList" :retailList="retailList" :decisionContact="decisionContact" :pageType="pageType" @getLabelData="getLabelData" @getCustomerInfo="getCustomerInfo" />
    </div>
    <div v-if="customerInfo.isAllot !== 1 && customerInfo.status === 1 && paramsUrl.readOnly !== 'true'" class="oper-bottom-btn">
      <van-button v-if="checkPer(['admin', 'app:expandCustomer:update'])" class="left-btn"  @click="toPage(`/storeExpansion/storeMapping?customerId=${customerInfo.id}`)">{{ $t('shared.mapping') }}</van-button>
      <van-button v-if="checkPer(['admin', 'app:expand:addOrUpdate'])" class="right-btn" @click="toPage(`/storeExpansion/visitSellIn?customerId=${customerInfo.id}`, 'visit')">{{ $t('shared.visitSellIn') }}</van-button>
    </div>
    <div v-if="!(customerInfo.isAllot !== 1 && customerInfo.status === 1) && !['record'].includes(paramsUrl.isRecord) && paramsUrl.readOnly !== 'true'" class="oper-bottom-btn">
      <!-- 选择工作项 @click="toPage(`/storeMaintain/workItem?customerId=${customerInfo.id}`)" -->
      <van-button class="already-oper-btn">{{ customerInfo.status === -1 ? $t('form.temporarilyClosed') : customerInfo.status === -2 ? $t('form.permanentlyClosed') : customerInfo.status === -3 ? $t('form.invalid') : $t('button.alreadyInOperation') }}</van-button>
    </div>
    <van-popup v-model="showGroup" position="bottom" :round="true" :style="{ height: '60%' }">
      <div class="popup-content">
        <div class="group-title">
          <div></div>
          <div class="title-item">{{ $t('shared.title.selectGroup') }}</div>
          <div class="edit-txt" @click="toPage('/store/groupManagement')">{{ $t('button.edit') }}</div>
        </div>
        <div class="group-content">
          <van-checkbox-group v-model="checkGroup">
            <van-cell-group>
              <van-cell
                v-for="(item, index) in groupList"
                clickable
                class="spec-item"
                :class="{'spec-item-checked': checkGroup.includes(item.id)}"
                :key="item.id"
                :title="item.labelName"
                @click="toggle(index)"
              >
                <template #right-icon>
                  <van-checkbox :name="item.id" ref="checkboxes" />
                </template>
              </van-cell>
            </van-cell-group>
          </van-checkbox-group>
          <div class="customize-btn" @click="editShow=true">{{ $t('shared.filter.customize') }}</div>
        </div>
        <div class="group-btn">
          <van-button class="cancel-btn" @click="handleOper('cancel')">{{ $t('button.cancel') }}</van-button>
          <van-button class="save-btn" type="primary" @click="handleOper('save')">{{ $t('button.save') }}</van-button>
        </div>
      </div>
    </van-popup>
    <van-dialog v-model="editShow" :title="$t('shared.title.createANewGroup')" show-cancel-button :confirm-button-text="$t('button.confirm')" :cancel-button-text="$t('button.cancel')" @confirm="handleConfirm">
      <div class="dialog-content">
        <van-field v-model="labelName" placeholder="" class="group-input" />
      </div>
    </van-dialog>
    <XuVisitDialog ref="xuVisitDialogRef" :currentVisitInfo="currentVisitInfo" :customerId="customerInfo.id" :pageType="pageType" />
  </div>
</template>

<script>
import { arsCustomerInfoApi } from '@/api/home'
import { arsLabelListApi, arsLabelBatchRelevancyAddApi, arsLabelAddOrUpdateApi } from '@/api/storePage'
import { Toast } from 'vant'
import { arsVisitLastApi } from '@/api/visit'
import { mapState } from 'vuex'
export default {
  components: {
    XuStoreInfo: () => import('@/components/XuStoreInfo'),
    XuVisitDialog: () => import('@/components/XuVisitDialog')
  },
  data () {
    return {
      pageType: 'storeExpansion',
      paramsUrl: {},
      customerInfo: {},
      decisionContact: {},
      retailList: [],
      shelfList: [],
      groupList: [],
      editShow: false,
      labelName: '',
      checkGroup: [],
      showGroup: false,
      currentVisitInfo: {},
      showPopover: false
    }
  },
  activated () {
    this.paramsUrl = this.$route.query
    this.getCustomerInfo()
  },
  deactivated () {
    this.$destroy()
  },
  computed: {
    ...mapState({
      globalData: 'globalData'
    }),
    actions () {
      const newArr = []
      if (this.customerInfo.isAllot !== 1 && this.customerInfo.status === 1) {
        newArr.push({ text: this.$t('shared.storeActivity'), icon: require('@/assets/images/map_time.png'), type: 'activity' })
      }
      newArr.push({ text: this.$t('shared.relevantVisitPlans'), icon: require('@/assets/images/record.png'), type: 'plan' })
      return newArr
    }
  },
  methods: {
    onSelect (action, index) {
      if (action.type === 'activity') {
        this.$router.push(`/shared/mappingActivity?customerId=${this.customerInfo.id}`)
      } else if (action.type === 'plan') {
        this.$router.push(`/visitPlan?targetId=${this.customerInfo.id}&targetType=0&pageType=${this.pageType}`)
      }
    },
    getCustomerInfo () {
      Toast.loading({
        message: this.$t('shared.loading'),
        forbidClick: true,
        duration: 0
      })
      arsCustomerInfoApi(this.paramsUrl.customerId).then(res => {
        Toast.clear()
        const { decisionContact, retailList, shelfProjectList } = res.data
        this.customerInfo = res.data
        this.decisionContact = decisionContact
        retailList.forEach(brandItem => {
          brandItem.productList = brandItem.productList.filter(subItem => {
            return !['', null].includes(subItem.retailPrice)
          })
        })
        const isShowRetailList = retailList.some(brandItem => {
          return brandItem.productList.length > 0
        })
        this.retailList = isShowRetailList ? retailList : []
        this.shelfList = shelfProjectList
      })
    },
    toPage (url, type) {
      if (!url) {
        return
      }
      if (type === 'visit') {
        if (!this.customerInfo.id) {
          return
        }
        Toast.loading({
          message: this.$t('shared.loading'),
          forbidClick: true,
          duration: 0
        })
        arsVisitLastApi(this.customerInfo.id, '1').then(res => {
          Toast.clear()
          this.currentVisitInfo = res.data
          if (res.data.lastType === 0) {
            this.$router.push(url)
          } else {
            this.$refs.xuVisitDialogRef.dialogShow = true
          }
        })
        return
      }
      this.$router.push(url)
      if (url === '/store/groupManagement') {
        this.showGroup = false
      }
    },
    handleOper (type, params = {}) {
      if (type === 'save') {
        if (this.checkGroup.length <= 0) {
          Toast(this.$t('tips.pleaseSelectAGroup'))
          return
        }
        const data = {
          labelIdList: this.checkGroup,
          relevancyId: this.paramsUrl.customerId
        }
        Toast.loading({
          message: this.$t('shared.loading'),
          forbidClick: true,
          duration: 0
        })
        arsLabelBatchRelevancyAddApi(data).then(res => {
          Toast.clear()
          this.showGroup = false
          this.getCustomerInfo()
        })
      } else if (type === 'cancel') {
        this.showGroup = false
      }
    },
    getLabelData () {
      Toast.loading({
        message: this.$t('shared.loading'),
        forbidClick: true,
        duration: 0
      })
      this.checkGroup = []
      arsLabelListApi('').then(res => {
        Toast.clear()
        this.groupList = res.data
        this.checkGroup = this.customerInfo.labelList.map(subItem => subItem.id)
        this.showGroup = true
      })
    },
    handleConfirm () {
      if (!this.labelName) {
        Toast(this.$t('tips.pleaseEnterGroupName'))
        return
      }
      const data = {
        id: '',
        type: 0,
        labelName: this.labelName
      }
      Toast.loading({
        message: this.$t('shared.loading'),
        forbidClick: true,
        duration: 0
      })
      arsLabelAddOrUpdateApi(data).then(res => {
        Toast.clear()
        this.getLabelData()
        this.labelName = ''
        this.editShow = false
      })
    },
    toggle (index) {
      this.$refs.checkboxes[index].toggle()
    }
  }
}
</script>

<style lang="less" scoped>
.store-detail {
  display: flex;
  flex-direction: column;
  height: 100%;
  .detail-main-content {
    flex: 1;
    overflow-y: auto;
  }
  .right-header {
    display: flex;
    align-items: center;
    margin-left: 10px;
    .icon-img {
      width: 20px;
      height: 20px;
    }
  }
  .mark-info {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 10px;
    font-weight: 700;
    color: #555;
    .customer-name {
      font-size: 14px;
      word-break: break-word;
      text-align: center;
    }
    .center-btn {
      padding: 2px 5px;
      border: 1px solid #307bff;
      color: #307bff;
      font-weight: 400;
      font-size: 12px;
      margin-right: 3px;
    }
    .incentive-label {
      background: rgba(238, 84, 27, 0.19);
      border: 1px solid #ee541b;
      color: #ee541b;
    }
  }
  .detail-btn {
    display: flex;
    box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.05);
    .current-btn,
    .more-btn {
      flex: 1;
      border: none;
      font-weight: bold;
    }
    .current-btn {
      background-color: #307bff;
      color: #fff;
    }
    .more-btn {
      color: #555;
    }
  }
}
.popup-content {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding-top: 16px;
  .group-title {
    display: flex;
    justify-content: space-between;
    margin-bottom: 5px;
    padding: 0 10px;
    .title-item {
      font-size: 15px;
      font-weight: bold;
    }
    .edit-txt {
      color: #307bff;
    }
  }
  .group-content {
    flex: 1;
    padding: 0 10px;
    padding-bottom: 10px;
    overflow-y: auto;
    .customize-btn {
      width: 80px;
      padding: 3px 0;
      color: #307bff;
      background-color: #e8effc;
      text-align: center;
      border-radius: 5px;
    }
  }
  /deep/.van-cell__title {
    font-size: 12px;
  }
  /deep/.van-cell-group {
    padding: 0px;
  }
  .spec-item {
    margin-bottom: 8px;
    padding: 5px 10px;
    border-radius: 8px;
    background-color: #f2f2f2;
    &:first-child {
      margin-top: 8px;
    }
  }
  .spec-item-checked {
    background-color: #e8effc;
    color: #007bff;
  }
  .group-btn {
    padding: 10px;
    background: #fff;
    display: flex;
    justify-content: space-between;
    box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.05);

    .van-button {
      flex: 1;
      margin: 0 5px;
      height: 40px;
      border-radius: 4px;
    }

    .cancel-btn {
      border: 1px solid #000;
      color: #000;
    }

    .save-btn {
      background: #307bff;
      border: none;
    }
  }
}
.dialog-content {
  padding: 20px 16px;
  .group-input {
    border: 1px solid #ebedf0;
    border-radius: 4px;
    padding: 5px 10px;
  }
}
.oper-bottom-btn {
  .already-oper-btn {
    width: 100%;
    background-color: #aaaaaa;
    border: none;
    color: #fff;
    font-weight: bold;
  }
}
/deep/.van-popover__action {
  width: 200px;
}
/deep/.van-popover__action-text {
  text-align: left;
}
</style>
